import { environment } from "../config/environment";
import { customFetch } from "./Auth";

export const getAllDoctorsCount = async () => {
  // on a good request it will return a count for all doctors currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/count-doctors`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getActiveVsTotal = async (range = "6m") => {
  // on a good request it will return a count for all doctors currently in the database
  // else it will return an error code
  try {
    const rangeQuery = range ? `?range=${encodeURIComponent(range)}` : "";
    const res = await customFetch(`${environment.apiUrl}/doctors/active-vs-total${rangeQuery}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getDailyActivations = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/daily-activations`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getRevenueBreakdown = async () => {
  // on a good request it will return a count for all doctors currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/active-vs-total`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getActiveDoctors = async () => {
  // on a good request it will return a count for all doctors currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/count-active-doctors`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getActiveSuperOrgsCount = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/revops-count-active-super-orgs`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getActiveSuperOrgsList = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/revops-active-super-orgs`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAllPatientsCount = async () => {
  // on a good request it will return a count for all patients currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/patients/count-patients`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getActiveUsageDetails = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/patients/active-usage-details`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getPatientsSeenThisMonth = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/patients/count-patients-seen-this-month`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAllPlgUsers = async () => {
  // on a good request it will return a count for all patients currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/count-plg-users`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAllSpecialties = async () => {
  // on a good request it will return a count for all patients currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/specialties`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();
      const refinedData = combiningSpecialties(data);

      return refinedData;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAllRevOpsSpecialties = async () => {
  // on a good request it will return a count for all patients currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/revops-specialties`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();
      // const refinedData = combiningSpecialties(data);

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAllCustomers = async () => {
  // on a good request it will return a count for all patients currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/super-orgs`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();
      const refinedData = combiningCustomers(data);

      return refinedData;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAllRevOpsCustomers = async () => {
  // on a good request it will return a count for all patients currently in the database
  // else it will return an error code
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/revops-super-orgs`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();
      const refinedData = combiningCustomers(data);

      return refinedData;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAllRevOpsCustomersLegend = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/revops-super-orgs`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();
      const refinedData = combiningCustomersForLegend(data);

      return refinedData;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export function renderSixMonthSpan() {
  const currentDate = new Date();

  function formatDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${year}`;
  }

  const endDate = formatDate(currentDate);

  const startDate = new Date();
  startDate.setMonth(currentDate.getMonth() - 5);
  const formattedStartDate = formatDate(startDate);

  return `${formattedStartDate} - ${endDate}`;
}

function combiningSpecialties(data) {
  const currentSpecialties = ["Orthopedics", "Oncology", "Podiatry", "Radiation Oncology", 
    "Dentist", "Obstetrics and Gynecology", "Endocrinology", "Pediatric Neurology", 
    "Urology", "Primary Care", "Astera", "Plastic Surgery", "PCSRI", "Coastal Cancer Center"];
  const custom = { name: "Custom", value: 0 };

  const res = [];

  for (let d of data) {
    if (!currentSpecialties.includes(d.name)) {
      custom.value += d.value;
    } else {
      res.push(d);
    }
  }

  res.push(custom);

  return res;
}

function combiningCustomers(data) {
  const customerPricing = {
    // Ironwood: { costPerUser: 200 },
    // TenOnc: { costPerUser: 250 },
    // Astera: { costPerUser: 300, aiBillingPrice: 100, aiBillingCount: 3 },
    // PCSRI: { costPerUser: 300 },
    // LACN: { costPerUser: 300 },
    // MOASD: { costPerUser: 300 },
    // cCARE: { costPerUser: 300, integrationMaintenance: 1250, aiBillingPrice: 100, aiBillingCount: 5 },
    // "Stripe 4D EMR": { costPerUser: 200 },
    // "Stripe standalone": { costPerUser: 150 },
  };
  const unknown = { name: "Unknown", value: 0 };
  const unpriced = { name: "Unpriced", value: 0 };
  const res = [];

  for (let d of data) {
    if (d?.name?.toLowerCase() === "unknown") {
      const count = typeof d.value === "number" ? d.value : Number(d.value) || 0;
      unknown.value += count;
      continue;
    }
    const pricing = customerPricing[d.name];
    if (!pricing) {
      const count = typeof d.value === "number" ? d.value : Number(d.value) || 0;
      unpriced.value += count;
      continue;
    }

    const count = typeof d.value === "number" ? d.value : Number(d.value) || 0;
    const perUser = pricing.costPerUser ?? 0;
    const maintenance = pricing.integrationMaintenance ?? 0;
    const aiBilling = (pricing.aiBillingPrice ?? 0) * (pricing.aiBillingCount ?? 0);

    res.push({ ...d, value: count * perUser + maintenance + aiBilling });
  }

  if (unknown.value > 0) {
    res.push(unknown);
  }
  if (unpriced.value > 0) {
    res.push(unpriced);
  }

  return res;
}

function combiningCustomersForLegend(data) {
  const customerPricing = {
    // Ironwood: { costPerUser: 200 },
    // TenOnc: { costPerUser: 250 },
    // Astera: { costPerUser: 300, aiBillingPrice: 100, aiBillingCount: 3 },
    // PCSRI: { costPerUser: 300 },
    // LACN: { costPerUser: 300 },
    // MOASD: { costPerUser: 300 },
    // cCARE: { costPerUser: 300, integrationMaintenance: 1250, aiBillingPrice: 100, aiBillingCount: 5 },
    // "Stripe 4D EMR": { costPerUser: 200 },
    // "Stripe standalone": { costPerUser: 150 },
  };

  return data
    .map((item) => {
      const rawName = item?.name || "";
      const loweredName = rawName.toLowerCase();
      if (loweredName === "unknown") {
        const count = typeof item.value === "number" ? item.value : Number(item.value) || 0;
        return { ...item, name: "Unknown", value: count, isUnknown: true };
      }
      if (loweredName === "n/a") {
        return null;
      }
      const normalizedName = rawName;
      const pricing = customerPricing[normalizedName];
      const count = typeof item.value === "number" ? item.value : Number(item.value) || 0;
      if (!pricing) {
        return { ...item, name: normalizedName, value: count, isUnpriced: true };
      }

      const perUser = pricing.costPerUser ?? 0;
      const maintenance = pricing.integrationMaintenance ?? 0;
      const aiBilling = (pricing.aiBillingPrice ?? 0) * (pricing.aiBillingCount ?? 0);

      return { ...item, name: normalizedName, value: count * perUser + maintenance + aiBilling };
    })
    .filter(Boolean);
}

export const getTotalNotes = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/count-notes`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data.itemCount;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAverageSummarizeTime = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/average-summarize-time`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data.averageSummarizeTimeInSeconds;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getAverageTranscribeTime = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/average-transcription-time`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data.averageTranscribeTimeInSeconds;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

const getClientDateContext = () => {
  const now = new Date();
  const date = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, "0"),
    String(now.getDate()).padStart(2, "0"),
  ].join("-");

  return {
    date,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};

export const getUploadToSummarizeAverage = async () => {
  try {
    const { date, timeZone } = getClientDateContext();
    const res = await customFetch(
      `${environment.apiUrl}/engineering/upload-to-chatgpt-average`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify({ date, tz: timeZone }),
      }
    );

    if (res.ok) {
      return await res.json();
    }

    console.error({ "Error": `${res.status} ${res.statusText}` });
    return null;
  } catch (error) {
    console.error({ "Error": error.message });
    return null;
  }
}

export const getRecentNotesCount = async () => {
  try {
    const { date } = getClientDateContext();
    const res = await customFetch(`${environment.apiUrl}/notes/jobs-with-conversation-id?date=${encodeURIComponent(date)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();
      return data.noteCount;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
      return null;
    }
  } catch (error) {
    console.error({ "Error": error.message })
    return null;
  }
}

// export const getNotesGenerated = async () => {
//   try {
//     const res = await customFetch(`${environment.apiUrl}/notes/notes-generated`,
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           "token": localStorage.token
//         }
//       });

//     if (res.ok) {
//       const data = await res.json();

//       return data;
//     } else {
//       console.error({ "Error": `${res.status} ${res.statusText}` });
//     }
//   } catch (error) {
//     console.error({ "Error": error.message })
//   }   
// }

// export const getTotalApiCalls = async () => {
//   try {
//     const res = await customFetch(`${environment.apiUrl}/notes/count-api-calls`,
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           "token": localStorage.token
//         }
//       });

//     if (res.ok) {
//       const data = await res.json();

//       return data;
//     } else {
//       console.error({ "Error": `${res.status} ${res.statusText}` });
//     }
//   } catch (error) {
//     console.error({ "Error": error.message })
//   }    
// }

export const getAllOrgs = async () => {
  try {

    const res = await customFetch(`${environment.apiUrl}/orgs/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }

  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getOneOrg = async (organization) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/orgs/specific-org/${encodeURIComponent(organization)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }

  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getRevOpsSuperOrgDoctors = async (organization) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/orgs/revops-specific-org/${organization}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }

  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const getPatientsById = async (user_id) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/patients/patients-by-id`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        },
        body: JSON.stringify({ user_id: user_id })
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }

  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export const queryNoteCountForDoctor = async (doctorString) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/count-notes-by-doctor/${doctorString}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying notes by doctor:", res.statusText);
      alert("Error querying notes by doctor");
    }
  } catch (error) {
    console.error("Error querying notes by doctor:", error);
  }
}

export const queryNoteStatusForDoctor = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/note-status-for-doctor/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying notes by doctor:", res.statusText);
      alert("Error querying notes by doctor");
    }
  } catch (error) {
    console.error("Error querying notes by doctor:", error);
  }
}

export const queryWeeklyNoteStatusForDoctor = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/note-status-for-week-doctor/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying notes by doctor:", res.statusText);
      alert("Error querying notes by doctor");
    }
  } catch (error) {
    console.error("Error querying notes by doctor:", error);
  }
}

export const queryDailyNoteStatusForDoctor = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/note-status-for-day-doctor/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying notes by doctor:", res.statusText);
      alert("Error querying notes by doctor");
    }
  } catch (error) {
    console.error("Error querying notes by doctor:", error);
  }
}

export const queryMonthlyUsageForDoctor = async (doctorString) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/usage-by-doctor/${doctorString}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying monthly usage by doctor:", res.statusText);
      alert("Error querying monthly usage by doctor");
    }
  } catch (error) {
    console.error("Error querying monthly usage by doctor:", error);
  }
}

export const queryTotalNotesForOrg = async (doctorArray) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/total-notes-by-doctors`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        },
        body: JSON.stringify({ doctorArray: doctorArray })
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying monthly usage by doctor:", res.statusText);
      alert("Error querying monthly usage by doctor");
    }
  } catch (error) {
    console.error("Error querying monthly usage by doctor:", error);
  }
}

export const queryProcessingNotesForDoctor = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes//get-processing-notes-for-doctor/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying processing notes by doctor:", res.statusText);
      alert("Error querying processing notes by doctor");
    }
  } catch (error) {
    console.error("Error querying processing notes by doctor:", error);
  }
}

export const queryNotesProcessing = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/total-notes-processing`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying processing notes:", res.statusText);
      alert("Error querying processing notes");
    }
  } catch (error) {
    console.error("Error querying processing notes:", error);
  }
}

export const queryDoctorsWithProcessingNotes = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/doctors-with-processing-notes`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying doctors with processing notes:", res.statusText);
      alert("Error querying doctors with processing notes");
    }
  } catch (error) {
    console.error("Error querying doctors with processing notes:", error);
  }
}

export const queryAllDoctors = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/all-doctors`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying all doctors:", res.statusText);
      alert("Error querying all doctors");
    }
  } catch (error) {
    console.error("Error querying all doctors:", error);
  }
}

export const queryDoctorsBySpecialty = async (specialty) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/by-specialty/${encodeURIComponent(specialty)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();
      return data;
    } else {
      console.error("Error querying doctors by specialty:", res.statusText);
      return [];
    }
  } catch (error) {
    console.error("Error querying doctors by specialty:", error);
    return [];
  }
}

export const getDoctorsByMonth = async (months) => {
  const empty = { rows: [], totalCount: 0, queryMs: null, roundTripMs: null };
  // roundTripMs times the whole fetch from here (network + server), queryMs is just the
  // server's own DB query time (passed through from the response) -- comparing the two
  // tells you whether a slow export is a slow query, or something else (network, a slow
  // dev-server proxy, etc).
  const roundTripStart = performance.now();
  try {
    const monthsList = Array.isArray(months) ? months : [months];
    const monthsQuery = monthsList.filter(Boolean).join(",");
    if (!monthsQuery) return empty;

    const url = new URL(`${environment.apiUrl}/doctors/revops-doctors-by-month`);
    url.searchParams.set("months", monthsQuery);

    const res = await customFetch(url.toString(),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    const roundTripMs = Math.round(performance.now() - roundTripStart);

    if (res.ok) {
      const data = await res.json();
      return {
        rows: Array.isArray(data?.rows) ? data.rows : [],
        totalCount: Number(data?.totalCount) || 0,
        queryMs: Number.isFinite(data?.queryMs) ? data.queryMs : null,
        roundTripMs,
      };
    } else {
      console.error("Error querying doctors by month:", res.statusText);
      return { ...empty, roundTripMs };
    }
  } catch (error) {
    console.error("Error querying doctors by month:", error);
    return { ...empty, roundTripMs: Math.round(performance.now() - roundTripStart) };
  }
}

export const queryDoctorsByRevOpsSpecialty = async (specialty) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/revops-by-specialty/${encodeURIComponent(specialty)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();
      return data;
    } else {
      console.error("Error querying doctors by specialty:", res.statusText);
      return [];
    }
  } catch (error) {
    console.error("Error querying doctors by specialty:", error);
    return [];
  }
}

export const queryAllDoctorsBySpecialties = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/by-specialties`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();
      return data;
    } else {
      console.error("Error querying all doctors by specialties:", res.statusText);
      const errorText = await res.text();
      console.error("Error response body:", errorText);
      return {};
    }
  } catch (error) {
    console.error("Error querying all doctors by specialties:", error);
    return {};
  }
}

export const querySingleDoctorData = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/all-of-the-doctors-data/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying single doctor data:", res.statusText);
      alert("Error querying single doctor data");
    }
  } catch (error) {
    console.error("Error querying single doctor data:", error);
  }
}

export const querySingleDoctorDataToUpdate = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/doctors-data-for-update/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying single doctor data:", res.statusText);
      alert("Error querying single doctor data");
    }
  } catch (error) {
    console.error("Error querying single doctor data:", error);
  }
}

export const querySpecialtiesForDropdown = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/specialties-for-update`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      data.sort((a, b) => a.specialty.localeCompare(b.specialty));

      return data;
    } else {
      console.error("Error querying specialties for dropdown:", res.statusText);
      alert("Error querying specialties for dropdown");
    }
  } catch (error) {
    console.error("Error querying specialties for dropdown:", error);
  }
}

export const queryOrgsForDropdown = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/orgs-for-update`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying orgs for dropdown:", res.statusText);
      alert("Error querying orgs for dropdown");
    }
  } catch (error) {
    console.error("Error querying orgs for dropdown:", error);
  }
}

export const updateDoctorFields = async (doctorObj, currentDatabase) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/update-doctor/${doctorObj.user_id}?db=${currentDatabase}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        },
        body: JSON.stringify(doctorObj)
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error updating doctor fields:", res.statusText);
      alert("Error updating doctor fields");
    }
  } catch (error) {
    console.error("Error updating doctor fields:", error);
  }
}

export const deleteDoctor = async (doctorId, username, currentDatabase) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/delete-doctor/${doctorId}?db=${currentDatabase}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        },
        body: JSON.stringify({ username: username })
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error deleting doctor:", res.statusText);
      alert("Error deleting doctor");
    }
  } catch (error) {
    console.error("Error deleting doctor:", error);
  }
}

export const updatePassword = async (doctorObj, currentDatabase) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/update-password/${doctorObj.user_id}?db=${currentDatabase}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        },
        body: JSON.stringify({ password: doctorObj.password, username: doctorObj.username, user_name: doctorObj.user_name, user_email: doctorObj.user_email, userEmail: doctorObj.userEmail })
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error updating password:", res.statusText);
      alert("Error updating password");
    }
  } catch (error) {
    console.error("Error updating password:", error);
  }
}

export async function deactivateUser(doctorObj, todaysDate) {
  const response = await customFetch(
    `${environment.apiUrl}/doctors/deactivate-user/${doctorObj.user_id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
      body: JSON.stringify({
        username: doctorObj.username,
        todaysDate,
      }),
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to deactivate user");
  }

  return data;
}

export async function reactivateUser(doctorObj, station) {
  const response = await customFetch(
    `${environment.apiUrl}/doctors/reactivate-user/${doctorObj.user_id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.token,
      },
      body: JSON.stringify({ station }),
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to reactivate user");
  }

  return data;
}

export const queryDoctorsWithPlgStatus = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/doctors-with-plg-status`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        }
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying doctors with plg status:", res.statusText);
      alert("Error querying doctors with plg status");
    }
  } catch (error) {
    console.error("Error querying doctors with plg status:", error);
  }
}

export const queryWeeklyNotesLeaderboardForDoctors = async (doctorArray, weekNumber, org) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/week-to-week-notes`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token,
        },
        body: JSON.stringify({ doctorArray, weekNumber, org })
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying weekly notes leaderboard for doctors:", res.statusText);
      alert("Error querying weekly notes leaderboard for doctors");
    }
  } catch (error) {
    console.error("Error querying weekly notes leaderboard for doctors:", error);
  }
}


export const generateDateRange = (weeks) => {
  const endDate = new Date();
  const startDate = new Date();

  const formattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
  }

  if (weeks === 1) {
    startDate.setDate(startDate.getDate() - 7 + 1);
  } else {
    startDate.setDate(startDate.getDate() - (7 * weeks) + 1);
    endDate.setDate(endDate.getDate() - (7 * (weeks - 1)));
  }

  return `${formattedDate(startDate)} - ${formattedDate(endDate)}`;
}

export const getMRNByPatientId = async (patientId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/reviews/patient/${patientId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying MRN by patient id:", res.statusText);
      alert("Error querying MRN by patient id");
    }
  } catch (error) {
    console.error("Error querying MRN by patient id:", error);
  }
}

const cleanUpKeys = (key) => {
  let newKey = "";

  for (let i = 0; i < key.length; i++) {
    if (key[i] === "_") {
      newKey += " ";
    } else {
      newKey += key[i]
    }
  }

  return newKey.toUpperCase();
}

const generateDashes = (length) => {
  let dashes = "";
  for (let i = 0; i < length; i++) {
    dashes += "-";
  }

  return dashes;
}

export const formatChartData = (data) => {
  const keys = Object.keys(data);
  let formattedString = "";

  for (let key of keys) {
    const formattedKey = cleanUpKeys(key);

    if (!Array.isArray(data[key])) {
      formattedString += `${formattedKey} \n${generateDashes(key.length + Math.floor(key.length / 2))}\n${data[key]}\n\n`;

    } else {
      let internalString = `${formattedKey} \n${generateDashes(key.length + Math.floor(key.length / 2))}\n`;

      data[key].forEach((item) => {
        const internalKeys = Object.keys(item);

        for (let internalKey of internalKeys) {
          internalString += `${item[internalKey]}\n`;
        }

      })

      formattedString += `${internalString} \n\n`;
    }
  }

  return formattedString;
};

export const getDoctorSignupAndFirstNote = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/doctor-signup-and-first-note/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying doctor signup and first note:", res.statusText);
      alert("Error querying doctor signup and first note");
    }
  } catch (error) {
    console.error("Error querying doctor signup and first note:", error);
  }
}

export const getDoctorsManuallyAddedPatientsForDay = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors//doctor-patient-input/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying manually added patients for day:", res.statusText);
      alert("Error querying manually added patients for day");
    }
  } catch (error) {
    console.error("Error querying manually added patients for day:", error);
  }
}

export const getMonthlyDoctorsManuallyAddedPatients = async (doctorId, month) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/doctor-patient-input-month/${doctorId}?month=${month}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying manually added patients for month:", res.statusText);
      alert("Error querying manually added patients for month");
    }
  } catch (error) {
    console.error("Error querying manually added patients for month:", error);
  }
}

export const getNewDoctorsThisWeek = async (status, helper = false) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/new-doctors-this-week?status=${status}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      if (helper) {
        return data;
      } else {
        return data.length;
      }
    } else {
      console.error("Error querying new doctors this week:", res.statusText);
      alert("Error querying new doctors this week");
    }
  } catch (error) {
    console.error("Error querying new doctors this week:", error);
  }
}

export const getNewDoctorsThisMonth = async (status, helper = false) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/new-doctors-this-month?status=${status}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      if (helper) {
        return data;
      } else {
        return data.length;
      }
    } else {
      console.error("Error querying new doctors this week:", res.statusText);
      alert("Error querying new doctors this week");
    }
  } catch (error) {
    console.error("Error querying new doctors this week:", error);
  }
}

export const getWeeklyDoctorUtilization = async () => {
  try {
    const res = await customFetch(`${environment.apiUrl}/doctors/utilization-this-week`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying weekly doctor utilization:", res.statusText);
      alert("Error querying weekly doctor utilization");
    }
  } catch (error) {
    console.error("Error querying weekly doctor utilization:", error);
  }
}

export const getPercentageUsage = async (doctorId) => {
  try {
    const res = await customFetch(`${environment.apiUrl}/patients/patient-status-by-doctor/${doctorId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error("Error querying percentage usage:", res.statusText);
      alert("Error querying percentage usage");
    }
  } catch (error) {
    console.error("Error querying percentage usage:", error);
  }
}

export const getPatientTypeBreakdown = async (org, queryParams='') => {
  try {
    const res = await customFetch(`${environment.apiUrl}/orgs/new-vs-fu/${org}${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        },
      }
    );

    if (res.ok) {
      const data = await res.json();
      
      return data;
    } else {
      console.error("Error querying patient type breakdown:", res.statusText);
      alert("Error querying patient type breakdown");
    }
  } catch (error) {
    console.error("Error querying patient type breakdown:", error);
  }
}

export async function postData(url = "", data = {}, method = "GET") {
  // Default options are marked with *
  const response = await customFetch(url, {
    method: method, // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    // Add the 'token' as a header to allow access to backend
    headers: {
      token: window.localStorage.getItem("token"),
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //body: JSON.stringify(data) // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

export async function getOrgDataForMonth(org, month) {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/org-data-for-month/${org}/${month}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();

      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}

export async function getOrgMonthlyOverview(org, monthsBack = 12) {
  try {
    const res = await customFetch(`${environment.apiUrl}/notes/org-monthly-overview/${org}/${monthsBack}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "token": localStorage.token
        }
      });

    if (res.ok) {
      const data = await res.json();
      
      return data;
    } else {
      console.error({ "Error": `${res.status} ${res.statusText}` });
    }
  } catch (error) {
    console.error({ "Error": error.message })
  }
}
